module.exports = __webpack_public_path__ + "static/media/ic_reload.023ada2c.png";